import { useMemo, useCallback } from "react";
import { useQuery, gql } from "@apollo/client";

const GET_CATEGORIES_CACHED = gql`
  query getCategoriesCached {
    getCategoriesCached(limit: 100) {
      name
      subcategories {
        name
      }
    }
  }
`;

const WHITESPACE_RE = /\s+/g;
const sanitize = (str) => str.replace(WHITESPACE_RE, '');

/**
 * 전체 카테고리/서브카테고리 이름을 flat 배열로 반환하고,
 * 검색어가 카테고리명과 매칭되는지 판별하는 함수를 제공하는 hook
 * @returns {{ categoryNames: string[], isCategoryMatched: (query: string) => boolean, loading: boolean }}
 */
export default function useCategoryNames() {
  const { data, loading } = useQuery(GET_CATEGORIES_CACHED);

  const categoryNames = useMemo(() => {
    if (!data?.getCategoriesCached) return [];

    const names = new Set();
    data.getCategoriesCached.forEach((category) => {
      names.add(category.name);
      if (category.subcategories) {
        category.subcategories.forEach((sub) => names.add(sub.name));
      }
    });

    return [...names];
  }, [data]);

  const isCategoryMatched = useCallback((query) => {
    if (!query || categoryNames.length === 0) return false;
    const sanitized = sanitize(query);
    return categoryNames.some((name) => sanitize(name) === sanitized);
  }, [categoryNames]);

  return { categoryNames, isCategoryMatched, loading };
}
